export default __webpack_public_path__ + "static/media/Ready Up.1d371a56.png";